import angular from 'angular'

/**
 * A way to give access to AngularJS modules from within a React
 * component. This should be used with great care. Also, since
 * this requires that AngularJS at least have gotten to the "run"
 * phase of its lifecycle, it's only useful in areas of the code
 * where we know AngularJS has been initialized.
 */
export let injector

export const moduleName = angular.module('react.ng.injector', []).run([
  '$injector',
  ($injector) => {
    injector = $injector
  }
]).name
